const parse = require("cssfontparser");

/**
 * Was getting "Declaration emit for this file requires using private name".
 * This `type` annotation is a workaround. See: https://stackoverflow.com/questions/60009092/declaration-will-not-emit-due-to-private-name-usage
 * @type {unknown}
 */
module.exports = function() {
	// Based off of https://html.spec.whatwg.org/multipage/scripting.html#canvasrenderingcontext2d
	// and things implemented by Chrome 46.0.2490.80.
	const context = {
		canvas: {
			width: 0,
			height: 0,
			style: {},
			getContext: function() {
				return context;
			},
		},
		globalAlpha: 1,
		globalCompositeOperation: "source-over",
		strokeStyle: "#000000",
		fillStyle: "#000000",
		shadowOffsetX: 0,
		shadowOffsetY: 0,
		shadowBlur: 0,
		shadowColor: "rgba(0, 0, 0, 0)",
		lineWidth: 1,
		lineCap: "butt",
		lineJoin: "miter",
		miterLimit: 10,
		lineDashOffset: 0,
		font: "10px sans-serif",
		textAlign: "start",
		textBaseline: "alphabetic",

		save: saveMockContext,
		restore: restoreMockContext,
		scale: function() {},
		rotate: function() {},
		translate: function() {},
		transform: function() {},
		setTransform: function() {},
		resetTransform: function() {},
		createLinearGradient: function() {}, // TODO
		createRadialGradient: function() {}, // TODO
		createPattern: function() {}, // TODO
		clearRect: function() {},
		fillRect: function() {},
		strokeRect: function() {},
		beginPath: function() {},
		fill: function() {},
		stroke: function() {},
		drawFocusIfNeeded: function() {},
		clip: function() {},
		isPointInPath: function() {}, // TODO
		isPointInStroke: function() {}, // TODO
		fillText: function() {},
		strokeText: function() {},
		measureText: measureTextInContext,
		drawImage: function() {},
		createImageData: function() {},
		getImageData: function() {},
		putImageData: function() {},
		getContextAttributes: function() {},
		setLineDash: function() {},
		getLineDash: function() {},
		closePath: function() {},
		moveTo: function() {},
		lineTo: function() {},
		quadraticCurveTo: function() {},
		bezierCurveTo: function() {},
		arcTo: function() {},
		rect: function() {},
		arc: function() {},
	};
	Object.defineProperty(context, "__stateStack", {
		enumerable: false,
		configurable: false,
		writable: false,
		value: [],
	});
	Object.defineProperty(context, "__unbalancedSaves", {
		enumerable: false,
		configurable: false,
		writable: true,
		value: 0,
	});
	return context;
};

const saveMockContext = function() {
	const copy = {};
	for (const k in this) {
		if (this.hasOwnProperty(k)) {
			copy[k] = this[k];
		}
	}
	this.__unbalancedSaves += 1;
	this.__stateStack.push(copy);
};

const restoreMockContext = function() {
	this.__unbalancedSaves -= 1;
	if (!this.__stateStack.length) {
		return;
	}
	const popped = this.__stateStack.pop();
	for (const k in this) {
		if (this.hasOwnProperty(k)) {
			this[k] = popped[k];
		}
	}
};

const measureTextInContext = function(text) {
	// Duplicates Font.js util's getSize logic to break a circular dependency.
	const parsed = parse(this.font);
	const size = (parsed && parsed.size) || 10;
	// Accurate for Courier font family, approximation otherwise.
	let coeff = 0.6;
	if (text === "|") {
		// Hack to avoid T42255 bandaid breaking things.
		coeff = 0.24;
	}
	return {
		width: size * coeff * String(text).length,
	};
};
